// src/app/slices/vfdSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IVfd, IVfdParams, AccessoryState } from '../models';

const initialState: AccessoryState<IVfd, IVfdParams> = {
  accessories: {},
  params: null,
};

const vfdSlice = createSlice({
  name: 'vfd',
  initialState,
  reducers: {
    setVfd: (state, action: PayloadAction<IVfd>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setVfdParams: (state, action: PayloadAction<IVfdParams>) => {
      state.params = action.payload;
    },
    deleteVfd: deleteAccessory,
  },
});

export const { setVfd, setVfdParams, deleteVfd } = vfdSlice.actions;

export default vfdSlice.reducer;
